<template>
	<b-row  class="min-vh-100">
		<b-col md="5" order="2" order-sm="2" order-md="1" class="auth-form-column">
			<div class="auth-form">
				<h1 v-html="$t('reset-password.form.title')"></h1>
				<p v-html="$t('reset-password.form.description')"></p>
				<b-form novalidate class="needs-validation" autocomplete="off">
                    <b-form-invalid-feedback v-if="errors.email" :state="!!errors.email" :force-show="true" tag="span">
                        {{errors.email }}
                    </b-form-invalid-feedback>
					<b-form-group :label="$t('reset-password.input.password_label')" label-for="password">
						<b-form-input
								id="password"
								v-model="password"
								minlength="8"
								type="password"
								required
								:placeholder="$t('reset-password.input.password_placeholder')"
						></b-form-input>
						<password v-model="password" :strength-meter-only="true"/>
                        <b-form-invalid-feedback v-if="errors.password" :state="!!errors.password" :force-show="true" tag="span">
                            {{errors.password }}
                        </b-form-invalid-feedback>
					</b-form-group>

					<b-form-group :label="$t('reset-password.input.password_confirmation_label')" label-for="password">
						<b-form-input
								id="password_confirmation"
								v-model="passwordConfirmation"
								type="password"
								required
								:placeholder="$t('reset-password.input.password_confirmation_placeholder')"
						></b-form-input>
                        <b-form-invalid-feedback v-if="errors.password_confirmation" :state="!!errors.password_confirmation" :force-show="true" tag="span">
                            {{errors.password_confirmation }}
                        </b-form-invalid-feedback>
					</b-form-group>
					<b-form-group class="mt-2">
						<b-button type="button" variant="primary" @click="changePassword()">
							{{ $t('reset-password.button.submit') }}<span class="icon-arrow-btn ml-3"></span>
						</b-button>
					</b-form-group>
				</b-form>
				<p class="font-weight-bold">{{ $t('reset-password.back_label') }} <router-link :to="{name:'login'}">{{ $t('reset-password.back_link') }}</router-link></p>
			</div>
		</b-col>
        <app-intro></app-intro>
	</b-row>
</template>

<script>
    import axios from 'axios';
    import { errors } from '../../mixins/errors';
    import Password from 'vue-password-strength-meter';

    export default {
        name: 'form-reset-password',
		components: {Password},
        mixins: [errors],
        data() {
            return {
                token: null,
                email: null,
                password: null,
                passwordConfirmation: null
            }
        },
        methods: {
            changePassword() {
                axios.post(process.env.MIX_API_PREFIX + 'reset/password', {
                    email: this.$route.params.email,
                    password: this.password,
                    token: this.$route.params.token,
                    password_confirmation: this.passwordConfirmation
                }).then(response => {
                    this.pushNotification(response.data.message, 'success');
                    this.$router.push({
                        name: 'login'
                    });
                }).catch(error => {
                    if (error.response) {
                        return this.handleResponseErrors(error.response);
                    }
                    this.pushNotification(error.message, 'danger');
                });
            }
        },
		mounted() {
			this.validationHandler()
		}
    }
</script>
